module.exports = __webpack_public_path__ + "static/img/HUARUN.19eae93.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/bankInfoBg/HUARUN.png
// module id = BQmd
// module chunks = 69